const posts = [
  { title: "Empowering Youth Through Skills Training", date: "Jan 15, 2026" },
  { title: "Healthcare Outreach Saves Hundreds", date: "Dec 30, 2025" },
  { title: "Education Scholarships Impact Report", date: "Nov 20, 2025" },
];

export default function Blog() {
  return (
    <section className="py-20 px-6 max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold mb-12 text-center text-[#2D033B]">
        News & Updates
      </h2>

      <div className="grid md:grid-cols-3 gap-8">
        {posts.map((post) => (
          <div
            key={post.title}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition border border-[#E5D9F2]"
          >
            <h3 className="text-xl font-semibold mb-2 text-[#2D033B]">
              {post.title}
            </h3>
            <p className="text-[#5A3D73] text-sm">{post.date}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
